import styled from 'styled-components';

type WrapperProps = {
  background?: string
};

const Wrapper = styled.div<WrapperProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 4px 8px;
  gap: 4px;
  height: 24px;
  background: ${(props) => (props.background ? props.background : props.theme.colors.white)};
  border-radius: 6px;
`;

export default { Wrapper };
